'use strict';

var MomentFormattingFilter = function MomentFormattingFilter(momentService, MomentConstants) {
  var defaultFormat = MomentConstants.FORMATS.DATE;

  /**
   *
   * @param {MomentFactory} moment
   * @param {string} format
   * @returns {string|undefined}
   */
  function formatMoment(moment, format) {
    return moment.value.format(format);
  }
  return function (value, formatName) {
    if (!momentService.isMoment(value)) {
      return value;
    }
    var format = MomentConstants.FORMATS[formatName] || defaultFormat;
    return formatMoment(value, format);
  };
};
MomentFormattingFilter.$inject = ['MomentService', 'MomentConstants'];
module.exports = MomentFormattingFilter;